export function keyBy<T>(collection: T[], iteratee: ((arg: T) => string | number) | string): { [key: string]: T } {
    return collection.reduce((previousValue, currentValue) => { previousValue[typeof iteratee == 'function' ? iteratee(currentValue) : (currentValue as any)[iteratee]] = currentValue; return previousValue }, {} as { [key: string]: T });
}

export function deepClone<T>(object: T): T {
    return window.structuredClone as any ? structuredClone(object) : JSON.parse(JSON.stringify(object));
}